module.exports = __webpack_public_path__ + "img/logo-idtrust-white.df3bd0d6.svg";